import React, { useState, useCallback, memo, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import { useSelector } from 'react-redux';
import { RootState } from '@/store';
import classNames from 'classnames';

// Memoize the AppLayout component to prevent unnecessary re-renders
const AppLayout: React.FC = memo(() => {
  const [sidebarExpanded, setSidebarExpanded] = useState(true);
  const { mode } = useSelector((state: RootState) => state.theme);

  // Use useCallback to memoize the function
  const toggleSidebar = useCallback(() => {
    setSidebarExpanded(prev => !prev);
  }, []);
  
  // Add an event listener for the custom toggle-sidebar event
  useEffect(() => {
    const handleToggleSidebarEvent = () => {
      setSidebarExpanded(prev => !prev);
    };
    
    window.addEventListener('toggle-sidebar', handleToggleSidebarEvent);
    
    // Cleanup
    return () => {
      window.removeEventListener('toggle-sidebar', handleToggleSidebarEvent);
    };
  }, []);

  // Dark class is managed globally by ThemeManager

  return (
    <div className={classNames('flex h-screen overflow-hidden', {
      'bg-gray-100': mode === 'light',
      'bg-gray-900 text-gray-200': mode === 'dark'
    })}>
      {/* Sidebar */}
      <Sidebar expanded={sidebarExpanded} />

      {/* Content area */}
      <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">
        {/* Header */}
        <Header toggleSidebar={toggleSidebar} />

        {/* Main content */}
        <main className="flex-grow p-4 sm:p-6 md:p-8">
          <Outlet />
        </main>

        {/* Footer 已被移除 */}
      </div>
    </div>
  );
});

export default AppLayout;